// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import _ from 'underscore';
import { featureFlagClient } from '@trello/feature-flag-client';

import { BaseDirectoryView } from './BaseDirectoryView';
import { DirectoryLegacyPowerUps as directoryLegacyPowerUps } from './DirectoryLegacyPowerUps';
import { DirectoryPluginItemView } from './DirectoryPluginItemView';
import { markdownAsHtml } from 'app/scripts/lib/markdown/format';
import { pluginIOCache } from 'app/scripts/views/internal/plugins/PluginIoCache';
import { PowerUpItemType } from 'app/src/components/PowerUp';
import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';
const t = recupWithHelpers('directory');
const powerUpItemDetailsT = recupWithHelpers('power_up_item_details');
const c = recupWithHelpers('directory_data_consent');
import notCompliantIcon from 'resources/images/directory/icons/notCompliant.svg';
import compliantIcon from 'resources/images/directory/icons/compliant.svg';
import React from 'react';
import pluginValidators from 'app/scripts/lib/plugins/plugin-validators';
import { applyBidiTooltip } from 'app/src/components/TrelloMarkdown/applyBidiTooltip';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { LazyPowerUpsDeprecationBanner } from 'app/src/components/PowerUpsDeprecationBanner/LazyPowerUpsDeprecationBanner';

class DirectoryListing extends React.Component {
  static initClass() {
    this.prototype.displayName = 'Directory Listing';

    this.prototype.render = t.renderable(function () {
      const {
        supportEmail,
        description,
        displayName,
        isGrandfathered,
        isCompliant,
        privacyPolicy,
        categories,
        onCategoryClick,
        isDeprecationEnabled,
        isDeprecated,
      } = this.props;

      return t.div('.directory-individual-listing', function () {
        t.div('.js-directory-listing');
        if (supportEmail) {
          let supportLink = supportEmail;

          const EMAIL_REGEX = /^[^@]+@[a-z0-9-]+(\.[a-z0-9-]+)+$/i;

          if (EMAIL_REGEX.test(supportLink)) {
            supportLink = `mailto:${supportEmail}?subject=${encodeURIComponent(
              displayName,
            )}`;
          }

          t.div('.directory-listing-support', () =>
            t.div('.support-list', function () {
              t.icon('email', { class: 'icon-lg' });
              t.a('.support-link', { href: supportLink }, () =>
                t.format('contact-support'),
              );
              if (pluginValidators.isValidHttp(privacyPolicy)) {
                t.icon('information', { class: 'icon-lg' });
                return t.a('.support-link', { href: privacyPolicy }, () =>
                  t.format('privacy-policy'),
                );
              }
            }),
          );
        } else {
          t.div('.directory-listing-categories', function () {
            t.icon('information', { class: 'icon-lg' });
            return t.div('.categories-list', () =>
              categories.map((category, index) => {
                if (index > 0) {
                  t.span('.category-link-delimiter', () => t.text('•'));
                }
                t.a(
                  '.category-link',
                  {
                    href: '#',
                    onClick() {
                      return onCategoryClick(category);
                    },
                  },
                  () => t.format(category),
                );
              }),
            );
          });
        }

        if (isGrandfathered) {
          t.p('.power-up-grandfathered', function () {
            powerUpItemDetailsT.format(
              'power-up-was-enabled-on-this-board-before-some-recent-changes-we-made',
              {
                name: displayName,
              },
            );
            return t.text(' 🎉');
          });
        }
        if (isDeprecationEnabled && isDeprecated) {
          t.div('.directory-listing-deprecation-warning');
        }
        t.div(
          '.directory-listing-content.markeddown',
          {
            ref: (node) => {
              if (node) {
                applyBidiTooltip(node);
              }
            },
          },
          () => t.raw(markdownAsHtml(description)),
        );
        return t.div('.directory-listing-compliance', function () {
          const src = isCompliant === false ? notCompliantIcon : compliantIcon;

          c.img('.directory-listing-compliance-icon', {
            src,
            alt: '',
            role: 'presentation',
          });
          if (isCompliant === false) {
            return c.format(
              'power-up-does-not-comply-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          } else if (isCompliant === true) {
            return c.format(
              'power-up-stores-data-complies-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          } else {
            return c.format(
              'power-up-complies-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          }
        });
      });
    });
  }
}

DirectoryListing.initClass();

class DirectoryListingView extends BaseDirectoryView {
  static initClass() {
    this.prototype.className = 'directory-listing-wrapper';
  }
  eventSource() {
    return 'boardDirectoryPowerUpDetailsScreen';
  }

  initialize({ directoryView, plugin, currentPage }) {
    this.directoryView = directoryView;
    this.plugin = plugin;
    this.currentPage = currentPage;

    super.initialize(...arguments);

    this.isDeprecationEnabled = featureFlagClient.get(
      'ecosystem.pup-deprecation-field',
      false,
    );
    this.isDeprecated = this.plugin.get('deprecation')?.sunsetDate;

    this.io = pluginIOCache.get(this.plugin);

    const powerUp = _.findWhere(directoryLegacyPowerUps, {
      id: this.plugin.id,
    });

    if (powerUp) {
      let needle;
      const { name } = powerUp;
      return (this.isGrandfathered =
        ((needle = name),
        Array.from(this.model.get('powerUps')).includes(needle)));
    }
  }

  navigateToCategory(category) {
    return this.directoryView.navigate({ section: 'category', category });
  }

  renderContent() {
    return (
      <DirectoryListing
        displayName={this.io.getName()}
        description={this.io.getDescription()}
        supportEmail={this.plugin.get('supportEmail')}
        privacyPolicy={this.plugin.get('privacyUrl')}
        categories={this.plugin.get('categories')}
        isGrandfathered={this.isGrandfathered}
        // eslint-disable-next-line react/jsx-no-bind
        onCategoryClick={(category) => this.navigateToCategory(category)}
        isCompliant={this.plugin.get('isCompliantWithPrivacyStandards')}
        isDeprecationEnabled={this.isDeprecationEnabled}
        isDeprecated={this.isDeprecated}
        isIntegration={(this.plugin.get('tags') || []).includes('integration')}
      />
    );
  }

  render() {
    super.render(...arguments);

    if (this.isDeprecationEnabled && this.isDeprecated) {
      const deprecatedBannerReactRoot = this.el.querySelector(
        '.directory-listing-deprecation-warning',
      );

      renderComponent(
        <LazyPowerUpsDeprecationBanner
          deprecatedPowerUps={[
            {
              ...this.plugin.get('deprecation'),
              name: this.io.getName(),
            },
          ]}
        />,
        deprecatedBannerReactRoot,
      );
    }

    this.appendSubview(
      this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Listing,
          plugin: this.plugin,
          currentPage: this.currentPage,
          directoryView: this.directoryView,
        },
        this.plugin.id,
      ),
      $('.js-directory-listing', this.$el),
    );

    const enabledPlugins = this.directoryView.getEnabledPlugins();

    this.directoryView.trackScreenEvent(this.eventSource(), {
      powerUpId: this.plugin.id,
      isEnabled: _.some(enabledPlugins, { id: this.plugin.id }) ? true : false,
      tags: this.plugin.get('tags'),
    });

    return this;
  }
}

DirectoryListingView.initClass();
export { DirectoryListingView };
